import _ from 'lodash'
import { cleanRequirementItems } from './clean-requirement-items'
import { cleanRequirementUpcharge } from './clean-requirement-upcharge'

export function cleanRequirements (menuBlob) {
  _.get(menuBlob, 'requirements', []).forEach(requirement => {
    cleanRequirement(requirement, menuBlob)
  })
}

export function cleanRequirement (requirement, menuBlob) {
  cleanRequirementItems(requirement, menuBlob)
  cleanRequirementUpcharge(requirement, menuBlob)
}
